import { render, staticRenderFns } from "./AddToCartButton.vue?vue&type=template&id=1740398e&scoped=true"
import script from "./AddToCartButton.vue?vue&type=script&lang=js"
export * from "./AddToCartButton.vue?vue&type=script&lang=js"
import style0 from "./AddToCartButton.vue?vue&type=style&index=0&id=1740398e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1740398e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1740398e')) {
      api.createRecord('1740398e', component.options)
    } else {
      api.reload('1740398e', component.options)
    }
    module.hot.accept("./AddToCartButton.vue?vue&type=template&id=1740398e&scoped=true", function () {
      api.rerender('1740398e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AddToCartButton.vue"
export default component.exports